// 一覧の絞り込み（上の帯の検索と、札）。
export interface Filter {
  q: string;
  /** "all"・"quick"・"genre:<名前>"・"subject:<名前>" */
  chip: string;
}

let state: Filter = { q: "", chip: "all" };
const listeners = new Set<(f: Filter) => void>();

export const getFilter = () => state;

export function setFilter(next: Partial<Filter>) {
  state = { ...state, ...next };
  listeners.forEach((fn) => fn(state));
}

export function onFilter(fn: (f: Filter) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
